import { Repl } from './repl'

(() => {
    let repl = new Repl();

    repl.run();
})();